import { render, staticRenderFns } from "./TheIndex.vue?vue&type=template&id=63ce6f80&scoped=true"
import script from "./TheIndex.vue?vue&type=script&lang=js"
export * from "./TheIndex.vue?vue&type=script&lang=js"
import style0 from "./TheIndex.vue?vue&type=style&index=0&id=63ce6f80&prod&lang=css"
import style1 from "./TheIndex.vue?vue&type=style&index=1&id=63ce6f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce6f80",
  null
  
)

export default component.exports